import React from 'react';
import { IoInformationCircle } from 'react-icons/io5'; // Example icon from 'react-icons'
import './Notification.scss';

const Notification = () => {
  return (
    <div className="notification">
      <IoInformationCircle className="notification-icon" />
      <span className="notification-text">Do not close the page during operation, otherwise data loss may occur</span>
    </div>
  );
};

export default Notification;
